<div #svgContainer class="{{svgContainerClass}}" style="{{svgContainerStyle}}">
</div>
